import { useEffect, useState } from 'react';

interface IUseABTestingProps {
  testName: string;
  daysToExpire?: number;
}

type ABTestValue = 'A' | 'B' | undefined;

function getCookie(cookieName: string) {
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function isValueValid(value: string) {
  return value === 'A' || value === 'B';
}

function generateExpDate(days: number) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  return `expires=${d.toUTCString()}`;
}

const useABTesting = ({
  testName,
  daysToExpire,
}: IUseABTestingProps): ABTestValue => {
  const [cookieValue, setCookieValue] = useState<ABTestValue>(undefined);

  useEffect(() => {
    const cookieName = `AB_${testName}`;
    const currentCookieValue = getCookie(cookieName);

    if (currentCookieValue && isValueValid(currentCookieValue))
      setCookieValue(currentCookieValue as ABTestValue);
    else {
      const newCookieValue = Math.random() < 0.5 ? 'A' : 'B';
      const expires = generateExpDate(daysToExpire || 365);

      document.cookie = `${cookieName}=${newCookieValue};${expires};path=/`;
      setCookieValue(newCookieValue);
    }
  }, [testName, daysToExpire]);

  return cookieValue;
};

export default useABTesting;
